import { QueryClientProvider } from '@tanstack/react-query';
import { useEffect } from 'react';
import { RouterProvider } from 'react-router';
import { PageLoader, Toaster } from '@/components/ui';
import { bootstrapAuth } from '@/features/auth/bootstrap';
import { useAuthStore } from '@/stores/auth.store';
import { queryClient } from './query-client';
import { router } from './router';

export function App() {
  const status = useAuthStore((s) => s.status);
  useEffect(() => {
    void bootstrapAuth();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      {status === 'booting' ? <PageLoader /> : <RouterProvider router={router} />}
      <Toaster />
    </QueryClientProvider>
  );
}
